import { createIcon } from '@chakra-ui/react'

export const RestoreDown = createIcon({
  displayName: 'RestoreDown',
  viewBox: '0 0 14 14',
  d: 'M0 14V3H11V14H0ZM1.7 12.3H9.2V4.8H1.7V12.3ZM12.2 11V1.8H3V0H14V11H12.2Z',
})
